import type { ConsoleRoute } from '../index';
import { ClaimDetailPage } from './ClaimDetailPage';
import { ClaimsQueuePage } from './ClaimsQueuePage';

/** §16.2 Claims queue: age, deadline, missing information, risk flags, external verification result, appeal and dual review. */
export const claimsRoutes: ConsoleRoute[] = [
  {
    path: 'claims',
    handle: { permission: 'claims.view', title: 'Claims queue' },
    element: <ClaimsQueuePage />,
  },
  { path: 'claims/:id', handle: { permission: 'claims.view', title: 'Claim' }, element: <ClaimDetailPage /> },
];
